var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSoftwareTesting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.5 7H48V1C48 0.734784 47.8946 0.48043 47.7071 0.292893C47.5196 0.105357 47.2652 0 47 0H15C14.7348 0 14.4804 0.105357 14.2929 0.292893C14.1054 0.48043 14 0.734784 14 1V7H3.5C2.57206 7.00103 1.68241 7.3701 1.02626 8.02626C0.370104 8.68241 0.00102566 9.57206 0 10.5V48.5C0.00102566 49.4279 0.370104 50.3176 1.02626 50.9737C1.68241 51.6299 2.57206 51.999 3.5 52H22.6737L21.2463 57H17C16.7348 57 16.4804 57.1054 16.2929 57.2929C16.1054 57.4804 16 57.7348 16 58V61C16 61.2652 16.1054 61.5196 16.2929 61.7071C16.4804 61.8946 16.7348 62 17 62H45C45.2652 62 45.5196 61.8946 45.7071 61.7071C45.8946 61.5196 46 61.2652 46 61V58C46 57.7348 45.8946 57.4804 45.7071 57.2929C45.5196 57.1054 45.2652 57 45 57H40.7537L39.3262 52H58.5C59.4279 51.999 60.3176 51.6299 60.9737 50.9737C61.6299 50.3176 61.999 49.4279 62 48.5V10.5C61.999 9.57206 61.6299 8.68241 60.9737 8.02626C60.3176 7.3701 59.4279 7.00103 58.5 7ZM25 2H37V5.5C37 5.63261 36.9473 5.75979 36.8536 5.85355C36.7598 5.94732 36.6326 6 36.5 6H25.5C25.3674 6 25.2402 5.94732 25.1464 5.85355C25.0527 5.75979 25 5.63261 25 5.5V2ZM25.5 8H36.5C37.1628 7.99934 37.7983 7.73573 38.267 7.26704C38.7357 6.79834 38.9993 6.16284 39 5.5V5H43V37H19V5H23V5.5C23.0007 6.16284 23.2643 6.79834 23.733 7.26704C24.2017 7.73573 24.8372 7.99934 25.5 8V8ZM16 2H23V3H18C17.7348 3 17.4804 3.10536 17.2929 3.29289C17.1054 3.48043 17 3.73478 17 4V38C17 38.2652 17.1054 38.5196 17.2929 38.7071C17.4804 38.8946 17.7348 39 18 39H44C44.2652 39 44.5196 38.8946 44.7071 38.7071C44.8946 38.5196 45 38.2652 45 38V4C45 3.73478 44.8946 3.48043 44.7071 3.29289C44.5196 3.10536 44.2652 3 44 3H39V2H46V40H16V2ZM44 59V60H18V59H44ZM23.3263 57L24.7537 52H37.2463L38.6738 57H23.3263ZM60 48.5C59.9997 48.8977 59.8415 49.2791 59.5603 49.5603C59.2791 49.8415 58.8977 49.9997 58.5 50H3.5C3.10228 49.9997 2.72094 49.8415 2.43971 49.5603C2.15847 49.2791 2.00033 48.8977 2 48.5V46H60V48.5ZM60 44H2V10.5C2.00033 10.1023 2.15847 9.72094 2.43971 9.43971C2.72094 9.15847 3.10228 9.00033 3.5 9H14V41C14 41.2652 14.1054 41.5196 14.2929 41.7071C14.4804 41.8946 14.7348 42 15 42H47C47.2652 42 47.5196 41.8946 47.7071 41.7071C47.8946 41.5196 48 41.2652 48 41V9H58.5C58.8977 9.00033 59.2791 9.15847 59.5603 9.43971C59.8415 9.72094 59.9997 10.1023 60 10.5V44Z",
    fill: "url(#paint0_linear_6_319)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 11V19C20 19.2652 20.1054 19.5196 20.2929 19.7071C20.4804 19.8946 20.7348 20 21 20H29C29.2652 20 29.5196 19.8946 29.7071 19.7071C29.8946 19.5196 30 19.2652 30 19V14.618L31.4472 13.8944C31.5657 13.8363 31.6716 13.7553 31.7586 13.6561C31.8457 13.5569 31.9122 13.4414 31.9544 13.3164C31.9966 13.1913 32.0137 13.0592 32.0046 12.9275C31.9955 12.7958 31.9604 12.6673 31.9014 12.5492C31.8423 12.4312 31.7605 12.326 31.6607 12.2397C31.5608 12.1535 31.4448 12.0878 31.3194 12.0466C31.1941 12.0053 31.0618 11.9893 30.9302 11.9995C30.7986 12.0096 30.6703 12.0457 30.5527 12.1056L30 12.382V11C30 10.7348 29.8946 10.4804 29.7071 10.2929C29.5196 10.1054 29.2652 10 29 10H21C20.7348 10 20.4804 10.1054 20.2929 10.2929C20.1054 10.4804 20 10.7348 20 11ZM22 12H28V13.382L25.1975 14.7832L24.7071 14.2929C24.6143 14.2 24.504 14.1264 24.3827 14.0761C24.2614 14.0258 24.1313 14 24 14C23.8687 14 23.7386 14.0258 23.6173 14.0761C23.496 14.1264 23.3857 14.2 23.2929 14.2929C23.2 14.3857 23.1264 14.496 23.0761 14.6173C23.0258 14.7386 23 14.8687 23 15C23 15.1313 23.0258 15.2614 23.0761 15.3827C23.1264 15.504 23.2 15.6143 23.2929 15.7071L24.2929 16.7071C24.4413 16.8556 24.6326 16.9536 24.8398 16.9872C25.047 17.0209 25.2595 16.9885 25.4472 16.8946L28 15.618V18H22V12Z",
    fill: "url(#paint1_linear_6_319)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5527 25.1056L30 25.382V24C30 23.7348 29.8946 23.4804 29.7071 23.2929C29.5196 23.1054 29.2652 23 29 23H21C20.7348 23 20.4804 23.1054 20.2929 23.2929C20.1054 23.4804 20 23.7348 20 24V32C20 32.2652 20.1054 32.5196 20.2929 32.7071C20.4804 32.8946 20.7348 33 21 33H29C29.2652 33 29.5196 32.8946 29.7071 32.7071C29.8946 32.5196 30 32.2652 30 32V27.618L31.4472 26.8944C31.5657 26.8363 31.6716 26.7553 31.7586 26.6561C31.8457 26.5569 31.9122 26.4414 31.9544 26.3164C31.9966 26.1913 32.0137 26.0592 32.0046 25.9275C31.9955 25.7958 31.9604 25.6673 31.9014 25.5492C31.8423 25.4312 31.7605 25.326 31.6607 25.2397C31.5608 25.1535 31.4448 25.0878 31.3194 25.0466C31.1941 25.0053 31.0618 24.9893 30.9302 24.9995C30.7986 25.0096 30.6703 25.0457 30.5527 25.1056V25.1056ZM28 31H22V25H28V26.382L25.1975 27.7833L24.7071 27.2929C24.5196 27.1053 24.2652 27 24 27C23.7348 27 23.4804 27.1053 23.2929 27.2929C23.1053 27.4804 23 27.7348 23 28C23 28.2652 23.1053 28.5196 23.2929 28.7071L24.2929 29.7071C24.4413 29.8556 24.6326 29.9536 24.8398 29.9872C25.047 30.0209 25.2595 29.9885 25.4472 29.8946L28 28.618V31Z",
    fill: "url(#paint2_linear_6_319)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34 13H41C41.2652 13 41.5196 12.8946 41.7071 12.7071C41.8946 12.5196 42 12.2652 42 12C42 11.7348 41.8946 11.4804 41.7071 11.2929C41.5196 11.1054 41.2652 11 41 11H34C33.7348 11 33.4804 11.1054 33.2929 11.2929C33.1054 11.4804 33 11.7348 33 12C33 12.2652 33.1054 12.5196 33.2929 12.7071C33.4804 12.8946 33.7348 13 34 13Z",
    fill: "url(#paint3_linear_6_319)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34 16H41C41.2652 16 41.5196 15.8946 41.7071 15.7071C41.8946 15.5196 42 15.2652 42 15C42 14.7348 41.8946 14.4804 41.7071 14.2929C41.5196 14.1054 41.2652 14 41 14H34C33.7348 14 33.4804 14.1054 33.2929 14.2929C33.1054 14.4804 33 14.7348 33 15C33 15.2652 33.1054 15.5196 33.2929 15.7071C33.4804 15.8946 33.7348 16 34 16Z",
    fill: "url(#paint4_linear_6_319)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34 19H39C39.2652 19 39.5196 18.8946 39.7071 18.7071C39.8946 18.5196 40 18.2652 40 18C40 17.7348 39.8946 17.4804 39.7071 17.2929C39.5196 17.1054 39.2652 17 39 17H34C33.7348 17 33.4804 17.1054 33.2929 17.2929C33.1054 17.4804 33 17.7348 33 18C33 18.2652 33.1054 18.5196 33.2929 18.7071C33.4804 18.8946 33.7348 19 34 19Z",
    fill: "url(#paint5_linear_6_319)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34 26H41C41.2652 26 41.5196 25.8946 41.7071 25.7071C41.8946 25.5196 42 25.2652 42 25C42 24.7348 41.8946 24.4804 41.7071 24.2929C41.5196 24.1054 41.2652 24 41 24H34C33.7348 24 33.4804 24.1054 33.2929 24.2929C33.1054 24.4804 33 24.7348 33 25C33 25.2652 33.1054 25.5196 33.2929 25.7071C33.4804 25.8946 33.7348 26 34 26Z",
    fill: "url(#paint6_linear_6_319)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34 29H41C41.2652 29 41.5196 28.8946 41.7071 28.7071C41.8946 28.5196 42 28.2652 42 28C42 27.7348 41.8946 27.4804 41.7071 27.2929C41.5196 27.1054 41.2652 27 41 27H34C33.7348 27 33.4804 27.1054 33.2929 27.2929C33.1054 27.4804 33 27.7348 33 28C33 28.2652 33.1054 28.5196 33.2929 28.7071C33.4804 28.8946 33.7348 29 34 29Z",
    fill: "url(#paint7_linear_6_319)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34 32H39C39.2652 32 39.5196 31.8946 39.7071 31.7071C39.8946 31.5196 40 31.2652 40 31C40 30.7348 39.8946 30.4804 39.7071 30.2929C39.5196 30.1054 39.2652 30 39 30H34C33.7348 30 33.4804 30.1054 33.2929 30.2929C33.1054 30.4804 33 30.7348 33 31C33 31.2652 33.1054 31.5196 33.2929 31.7071C33.4804 31.8946 33.7348 32 34 32Z",
    fill: "url(#paint8_linear_6_319)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_319",
    x1: 31,
    y1: 0,
    x2: 31,
    y2: 62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#2351DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2351DC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6_319",
    x1: 26.0035,
    y1: 10,
    x2: 26.0035,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#2351DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2351DC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6_319",
    x1: 26.0035,
    y1: 23,
    x2: 26.0035,
    y2: 33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#2351DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2351DC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6_319",
    x1: 37.5,
    y1: 11,
    x2: 37.5,
    y2: 13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#2351DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2351DC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6_319",
    x1: 37.5,
    y1: 14,
    x2: 37.5,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#2351DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2351DC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6_319",
    x1: 36.5,
    y1: 17,
    x2: 36.5,
    y2: 19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#2351DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2351DC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6_319",
    x1: 37.5,
    y1: 24,
    x2: 37.5,
    y2: 26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#2351DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2351DC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6_319",
    x1: 37.5,
    y1: 27,
    x2: 37.5,
    y2: 29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#2351DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2351DC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_6_319",
    x1: 36.5,
    y1: 30,
    x2: 36.5,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#2351DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2351DC",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoftwareTesting);
export default __webpack_public_path__ + "static/media/softwareTesting.72895243cf840e791851bcb56551a0c7.svg";
export { ForwardRef as ReactComponent };